/* BENLING cart sidebar: the header cart icon opens it from the right. It shows what is in the cart (or "Your cart is empty")
   with a few suggested watches below. The content is rendered by Shopify (sections/cart-drawer.liquid) and fetched again
   every time the sidebar opens or a quantity changes, so prices and stock are always the real ones.
   Without JavaScript the cart icon still opens the normal cart page. Vanilla JS, no dependencies. */
(function () {
  'use strict';

  var lastFocus = null;
  var working = false;

  function root() { return document.querySelector('[data-cart-drawer]'); }
  function isOpen() { var r = root(); return !!r && r.classList.contains('is-open'); }
  function content(r) { return (r || root()).querySelector('[data-cart-content]'); }

  function focusables(r) {
    return Array.prototype.slice.call(r.querySelectorAll('a[href], button:not([disabled])')).filter(function (el) { return el.offsetParent !== null; });
  }

  /* header bubble + screen-reader text */
  function updateCount(n) {
    var link = document.querySelector('.site-header__cart');
    if (!link) return;
    var bubble = link.querySelector('.site-header__cart-count');
    if (n > 0) {
      if (!bubble) {
        bubble = document.createElement('span');
        bubble.className = 'site-header__cart-count';
        bubble.setAttribute('aria-hidden', 'true');
        link.appendChild(bubble);
      }
      bubble.textContent = n;
    } else if (bubble) {
      bubble.remove();
    }
    var label = link.getAttribute('data-count-label');
    var hidden = link.querySelector('.visually-hidden');
    if (label && hidden) hidden.textContent = label.replace('9999', n);
  }

  function swap(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = doc.querySelector('[data-cart-content]');
    var cur = content();
    if (!next || !cur) return false;
    var had = document.activeElement;
    var spec = had && had.getAttribute ? { key: had.getAttribute('data-cart-key'), qty: had.getAttribute('data-cart-qty') } : null;
    var before = cur.querySelector('.cdrawer__scroll');
    var top = before ? before.scrollTop : 0;
    var kids = document.importNode(next, true).childNodes;
    while (cur.firstChild) cur.removeChild(cur.firstChild);
    Array.prototype.slice.call(kids).forEach(function (n) { cur.appendChild(n); });
    cur.setAttribute('data-count', next.getAttribute('data-count') || '0');
    var after = cur.querySelector('.cdrawer__scroll');
    if (after) after.scrollTop = top;
    updateCount(parseInt(cur.getAttribute('data-count'), 10) || 0);
    // keep keyboard focus on the same control when the list is redrawn
    if (isOpen() && (!document.activeElement || document.activeElement === document.body || !root().contains(document.activeElement))) {
      var again = spec && spec.key ? cur.querySelector('[data-cart-key="' + spec.key + '"][data-cart-qty]') : null;
      var f = again || cur.querySelector('[data-cart-close]');
      if (f) f.focus();
    }
    return true;
  }

  function refresh() {
    var r = root();
    if (!r) return Promise.resolve();
    var url = r.getAttribute('data-url-section');
    url += (url.indexOf('?') > -1 ? '&' : '?') + 't=' + Date.now();
    return window.fetch(url, { headers: { Accept: 'text/html' }, credentials: 'same-origin' })
      .then(function (res) { if (!res.ok) throw new Error('cart ' + res.status); return res.text(); })
      .then(swap)
      .catch(function () { /* keep showing what is already there */ });
  }

  function message(text) {
    var m = root().querySelector('[data-cart-msg]');
    if (!m) return;
    m.textContent = text;
    m.hidden = !text;
  }

  function change(key, qty) {
    var r = root();
    if (!r || working) return;
    working = true;
    r.classList.add('is-busy');
    var body = { id: key, quantity: qty, sections: 'cart-drawer', sections_url: window.location.pathname };
    window.fetch(r.getAttribute('data-url-change'), {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (out) {
        var html = out.ok && out.data && out.data.sections && out.data.sections['cart-drawer'];
        if (html && swap(html)) return;
        return refresh().then(function () {
          // stock limit or a cart that changed elsewhere: tell the visitor, the list above is already up to date
          message((out.data && (out.data.message || out.data.description)) || r.getAttribute('data-error') || '');
        });
      })
      .catch(function () { return refresh().then(function () { message(r.getAttribute('data-error') || ''); }); })
      .then(function () { working = false; r.classList.remove('is-busy'); });
  }

  function open() {
    var r = root();
    if (!r) return;
    lastFocus = document.activeElement;
    r.removeAttribute('inert');
    r.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    Array.prototype.forEach.call(document.querySelectorAll('[data-cart-open]'), function (o) { o.setAttribute('aria-expanded', 'true'); });
    window.setTimeout(function () {
      var f = r.querySelector('[data-cart-close].icon-btn') || focusables(r)[0];
      if (f) f.focus();
    }, 60);
    refresh();
  }

  function close() {
    var r = root();
    if (!r || !r.classList.contains('is-open')) return;
    r.classList.remove('is-open');
    r.setAttribute('inert', '');
    document.body.style.overflow = '';
    Array.prototype.forEach.call(document.querySelectorAll('[data-cart-open]'), function (o) { o.setAttribute('aria-expanded', 'false'); });
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null;
    if (!t) return;
    var opener = t.closest('[data-cart-open]');
    if (opener && root()) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      open();
      return;
    }
    var r = root();
    if (!r || !r.contains(t)) return;
    if (t.closest('[data-cart-close]')) { close(); return; }
    var step = t.closest('[data-cart-qty]');
    if (step) {
      e.preventDefault();
      message('');
      change(step.getAttribute('data-cart-key'), parseInt(step.getAttribute('data-cart-qty'), 10) || 0);
    }
  });

  document.addEventListener('keydown', function (e) {
    var r = root();
    if (!r || !r.classList.contains('is-open')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables(r);
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  window.BenlingCart = { open: open, close: close, refresh: refresh };
})();
